<dashboard-edit
    [dashboard]="dashboard$ | async"
    [categories]="categories$ | async"
    [allCategories]="allCategories$ | async"
    (eventBus)="handleEventBus($event)"
></dashboard-edit>
